import { ROUTES } from "@/constants/routes";
import { useAppNavigate } from "@/hooks/pane-routing";
import { route } from "@/utils/route";
import { useCallback } from "react";

/** Opens `ConnectionPane` for an integration id in the right pane. */
export function useOpenConnection() {
  const appNavigate = useAppNavigate();

  return useCallback(
    (integrationId: string) => {
      if (!integrationId) return;
      appNavigate({
        pane: "rightPane",
        to: route(ROUTES.SETTINGS.CONNECTORS_SETTINGS, { integrationId }),
      });
    },
    [appNavigate],
  );
}
